module.exports = __webpack_public_path__ + "img/espy-analytics-long-dark-bg.80d9b648.svg";